__webpack_require__.p = "/Tuesday_HW_Task/";